<script>
  export let options, params;

  const kpis = [
    { "group_code": 7, "title": "Pipeline: Quota Ratio"},
    { "group_code": 8, "title": "Win Rate $"},
    { "group_code": 29, "title": "MQL's Generated"},
    // { "group_code": 409, "title": "Cost per MQL Generated"},
    { "group_code": 30, "title": "MQL to SAL Conversion %"},
    // { "group_code": 410, "title": "% MQLS that convert to Closed Won Opps"},
    // { "group_code": 414, "title": "% of Marketing Influenced New Business Bookings"},
    { "group_code": 44, "title": "Open Sales Territories (Quota Bearing)"},
    // { "group_code": 417, "title": "Total New Business Sales Achievement (Bookings)"},
    // { "group_code": 418, "title": "% of Reps Making Quota (YTD)"}
  ];

  let selectedKpiTitle;
  let onSelectKpi = function(groupCode){
    groupCode = (!isNaN(groupCode) ? groupCode : 7); // Pipeline: Quota Ratio set as default kpi
    let selectedKpi;
    if(selectedKpi = kpis.filter(kpi => kpi.group_code == groupCode)[0]){
      selectedKpiTitle = selectedKpi.title;
    }else{
      selectedKpiTitle = selectedKpi.title;
      groupCode = 7;
    }
    options.subMenu = groupCode;
  }
  // Default selected kpi title
  if(params && params.subMenu){
    onSelectKpi(params.subMenu);
  }else{
    onSelectKpi(7);
  }
</script>

<div class="offset-2 col-4 mt-3 pr-0">
    <div class="dropdown" id="charts-selector" >
        <button class="btn dropdown-toggle dropdown-date-selector" type="button" id="dropdownDate" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            { selectedKpiTitle }
        </button>
        <div class="dropdown-menu mw-100" aria-labelledby="dropdownDate">
          {#each kpis as kpi}
             <a on:click={ () => onSelectKpi(kpi.group_code)}
              href="/{options.menu.url}/{options.chartOrgs }/{kpi.group_code}/{options.year}/{options.month}"
              class="dropdown-item">
                {kpi.title}
            </a>
          {/each}
        </div>
    </div>
</div>
